import Typography from "@mui/material/Typography";
import PageTitleWrapper from "@/components/PageTitleWrapper";

const TopWrapper = ({ title, subtitle }: { title: string, subtitle: string }) => {
    return (
        <PageTitleWrapper>
            <Typography component='h3' sx={{
                margin: '0px 0px 4px',
                fontWeight: 700,
                fontSize: '25px',
                lineHeight: 1.4,
            }} >
                {title}
            </Typography>
            <Typography component='p' sx={{
                margin: '0px',
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: 1.4,
                color: '#6b778c',
            }} >
                {subtitle}
            </Typography>
        </PageTitleWrapper>


    );
}

export default TopWrapper;